import TagsNavigation from "./TagsNavigation";

type TagsNavigationWrapperProps = {
  tagTypesConfig?: Record<string, unknown>;
  selectedTab?: string;
};

const TagsNavigationWrapper = ({
  tagTypesConfig,
  selectedTab,
}: TagsNavigationWrapperProps) => {
  return (
    <TagsNavigation
      tagTypesConfig={tagTypesConfig}
      isSelected={selectedTab === "tagsTree"}
    />
  );
};

export default TagsNavigationWrapper;
